export class TimesheetService {
  static $inject = ['$state', 'AuthService', 'Timerecord'];

  constructor(
    private $state,
    private AuthService,
    private Timerecord,
  ) { }

  gotoTimesheet(currentUser?) {
    if (!currentUser) {
      this.AuthService.me().then((user) => this.doGotoTimesheet(user));
    } else {
      this.doGotoTimesheet(currentUser);
    }
  }

  private doGotoTimesheet(currentUser) {
    this.Timerecord.firstIncompleteDay({
      memberId: currentUser.id,
    }).then((day) => {
      const theDay = moment(day.date);
      this.$state.go('app.timesheet.weekly', {
        userId: currentUser.id,
        year: theDay.year(),
        week: theDay.week(),
      });
    });
  }
}
